import api from "./api";



const inquireProfileInfo=async( id) =>{
	
	const apiPath = `/profileinfo/inquireprofileinfo/${id}`;
	console.log("profileinfo " + apiPath);
	const response = api.get(apiPath);
	return response;
}

const inquireArtworks=async( id) =>{
	
	const apiPath = `/profileinfo/inquireartworks/${id}`;
	console.log("inquireArtworks " + apiPath);
	const response = api.get(apiPath);
	return response;
}

const inquireFollower=async( id) =>{
	
	const apiPath = `/profileinfo/inquirefollower/${id}`;
	console.log("inquirefollower " + apiPath);
	const response = api.get(apiPath);
	return response;
}

const inquireFollowed=async( id) =>{
	
	const apiPath = `/profileinfo/inquirefollowed/${id}`;
	console.log("inquirefollowed " + apiPath);
	const response = api.get(apiPath);
	return response;
}


const save=(apiParams) =>{
	
	const apiPath = `/profileinfo/save`;  
	apiParams={ ...apiParams, tenantId: 1 };


	console.log("save profile " + apiPath);
	let url=apiPath;

	
	let data=apiParams;

	const response = api.post(url ,data);
	return response;
}


const addFollow=(profileID) =>{
	
	const apiPath = `/profileinfo/addfollow?profileID=${profileID}`;  
	

	let url=apiPath;

	

	const response = api.post(url);
	return response;
}



const removeFollow=(profileID) =>{
	
	const apiPath = `/profileinfo/removefollow?profileID=${profileID}`;  
	

	let url=apiPath;

	

	const response = api.post(url);
	return response;
}



const ProfileService = {
	inquireProfileInfo,
	inquireArtworks,
	save,
	addFollow,
	removeFollow,
	inquireFollower,
	inquireFollowed,
	
};

export default ProfileService;
